import { object, record, string, literal, union } from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const centralizedTour = object({
  type: literal('centralizedTour'),
  tourId: string
});
const centralizedTourWithOverrides = object({
  type: literal('centralizedTourWithOverrides'),
  tourId: string,
  overrides: object({
    targetElementSelectorOverrides: record(string, string) // stepId -> targetElementSelector
  })
});
const tour = union(centralizedTour, centralizedTourWithOverrides);
export let TourType;
(function (TourType) {
  TourType["CENTRALIZED_TOUR"] = "centralizedTour";
  TourType["CENTRALIZED_TOUR_WITH_OVERRIDES"] = "centralizedTourWithOverrides";
})(TourType || (TourType = {}));
const startTourReply = defineMessage({
  type: 'startTourReply',
  payloadSchema: object({
    status: union(literal('success'), literal('error'))
  })
});
const startTour = defineMessage({
  type: 'startTour',
  payloadSchema: tour,
  reply: startTourReply
});
export const tourMessages = {
  startTour,
  startTourReply
};